import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import PageHero from '@/components/feature/PageHero';
import { Link } from 'react-router-dom';

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <PageHero label="About Us" title="会社概要" />

      {/* Mission */}
      <section className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center">
            <div>
              <span className="text-sky-400 text-xs font-medium tracking-widest uppercase">Our Mission</span>
              <h2 className="text-2xl md:text-3xl font-light text-slate-800 mt-3 mb-6" style={{ fontFamily: "'Noto Serif JP', serif" }}>
                美容の力で、<br /><span className="font-semibold">ビジネスを輝かせる</span>
              </h2>
              <div className="w-12 h-0.5 bg-sky-300 mb-6"></div>
              <p className="text-slate-500 text-sm leading-relaxed mb-4">
                合同会社リンクは、美容業界に特化したマーケティング支援・コンサルティング・教育事業を展開する会社です。
              </p>
              <p className="text-slate-500 text-sm leading-relaxed mb-4">
                美容に関する深い専門知識と、最新のマーケティング手法を組み合わせることで、クライアントのビジネス成長を力強くサポートします。
              </p>
              <p className="text-slate-500 text-sm leading-relaxed">
                「美しさ」と「ビジネス」をつなぐ架け橋として、美容業界の発展に貢献することが私たちの使命です。
              </p>
            </div>
            <div className="relative rounded-2xl overflow-hidden h-96">
              <img
                src="https://readdy.ai/api/search-image?query=elegant%20Japanese%20beauty%20company%20office%20interior%20minimal%20clean%20white%20light%20blue%20accent%20flowers%20desk%20professional%20feminine%20aesthetic&width=600&height=500&seq=about2&orientation=portrait"
                alt="合同会社リンク オフィス"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Company Info */}
      <section className="py-16 bg-sky-50/50">
        <div className="max-w-4xl mx-auto px-6">
          <div className="text-center mb-12">
            <span className="text-sky-400 text-xs font-medium tracking-widest uppercase">Company Info</span>
            <h2 className="text-2xl font-light text-slate-800 mt-3" style={{ fontFamily: "'Noto Serif JP', serif" }}>
              会社情報
            </h2>
          </div>

          <div className="bg-white rounded-2xl overflow-hidden">
            {[
              { label: '会社名', value: '合同会社リンク' },
              { label: '設立', value: '令和6年11月13日' },
              { label: '所在地', value: '〒171-0052\n東京都豊島区南長崎三丁目7番6号\nグランエッグス落合07号' },
              { label: '事業内容', value: '美容関連製品およびサービスのマーケティング支援\n美容に関する情報の提供およびコンサルティング業務\n美容に関するオンライン講座、セミナー、ワークショップの企画及び運営' },

            ].map((item, i) => (
              <div
                key={item.label}
                className={`flex flex-col sm:flex-row gap-2 sm:gap-8 px-8 py-5 text-sm ${
                  i % 2 === 0 ? 'bg-white' : 'bg-sky-50/50'
                }`}
              >
                <span className="text-sky-400 font-medium w-24 flex-shrink-0">{item.label}</span>
                <span className="text-slate-600 whitespace-pre-line">{item.value}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-12">
            <span className="text-sky-400 text-xs font-medium tracking-widest uppercase">Our Values</span>
            <h2 className="text-2xl font-light text-slate-800 mt-3" style={{ fontFamily: "'Noto Serif JP', serif" }}>
              私たちの価値観
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              { icon: 'ri-heart-line', title: '誠実さ', desc: 'クライアントの成功を自分ごととして考え、誠実に向き合います。' },
              { icon: 'ri-sparkling-line', title: '専門性', desc: '美容業界の深い知識と最新のマーケティング手法で、質の高いサービスを提供します。' },
              { icon: 'ri-links-line', title: 'つながり', desc: '美容と人、ビジネスと夢をつなぐ架け橋として、業界の発展に貢献します。' },
            ].map((v) => (
              <div key={v.title} className="text-center p-8 bg-sky-50 rounded-2xl">
                <div className="w-14 h-14 flex items-center justify-center rounded-full bg-white mx-auto mb-5">
                  <i className={`${v.icon} text-sky-400 text-2xl`}></i>
                </div>
                <h3 className="text-base font-semibold text-slate-800 mb-3">{v.title}</h3>
                <p className="text-slate-500 text-sm leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-sky-50">
        <div className="max-w-2xl mx-auto px-6 text-center">
          <h2 className="text-2xl font-light text-slate-800 mb-4" style={{ fontFamily: "'Noto Serif JP', serif" }}>
            一緒に美容ビジネスを成長させましょう
          </h2>
          <p className="text-slate-500 text-sm mb-8">まずはお気軽にご相談ください。初回相談は無料です。</p>
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 px-8 py-3 rounded-full bg-sky-300 text-white text-sm font-medium hover:bg-sky-400 transition-colors cursor-pointer whitespace-nowrap"
          >
            無料相談はこちら
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
